import React, { memo } from 'react';
import Table from '../../../../components/_table/Table';
import Panel from '../../../../components/outline/Panel';
import { columns } from './columns';
import Button from '../../../../components/Button';
import './PointRankingList.scss';

const PointRankingList = (props) => {
  const { pointRankingList, sortOption, pagination, getList, toggleModal, getExcelDownload } = props;

  return (
    <div className="point-ranking-list">
      <Panel>
        <div className="panel-body">
          <div className="excel-button">
            <Button isRadius color="primary" text="엑셀 다운로드" onClick={getExcelDownload} />
          </div>

          <Table
            columns={(utils) =>
              columns({
                pageNum: pagination.pageNum,
                pageSize: pagination.pageSize,
                pointRankingList,
                toggleModal,
                ...utils,
              })
            }
            rowKey={(record) => record.id}
            pagination={pagination}
            sortOption={sortOption}
            list={pointRankingList}
            size="small"
            scroll={{ x: true }}
            bordered={true}
            getList={getList}
          />
        </div>
      </Panel>
    </div>
  );
};

export default memo(PointRankingList);
